module.exports = __webpack_public_path__ + "img/icon_cantract.422dd204.png";